import Glide from "@glidejs/glide";
import "@glidejs/glide/dist/css/glide.core.min.css";
import "@glidejs/glide/dist/css/glide.theme.min.css";

declare global {
  interface Window {
    Glide: typeof Glide;
  }
}

window.Glide = Glide;
